// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"d9272874","453":"7e43b7fa","569":"3bd35245"}[chunkId] + ".chunk.js";
};